<div class="contentcontainer">
  @if (showSearch()) {
    <div class="searchBox">
      <aecom-textbox
        [theme]="'light'"
        [(ngValue)]="searchText"
        placeholder="Search"
        iconLeft="icon-basic_magnifier"
        (ngValueChange)="updateData()"
      ></aecom-textbox>
    </div>
  }

  <div class="contentBox">
    @for (item of result; track item) {
      <div class="responseBox">
        <div class="responseHeader">
          <span>{{ item.ReviewerName }}</span>
          @if (item.ReviewerOrganization && item.ReviewerOrganization !== '') {
            <span>
              <span class="responseHeaderSeparate">|</span>{{ item.ReviewerOrganization }}
            </span>
          }
          @if (item.ReviewerTrackName && item.ReviewerTrackName !== '') {
            <span>
              <span class="responseHeaderSeparate">|</span>{{ item.ReviewerTrackName }}
            </span>
          }
          <div class="responseHeaderDate">{{ item.DateUpdated }}</div>
          <div class="responseHeaderCollapse" (click)="item.Collapse = !item.Collapse">
            <i
              [ngClass]="item.Collapse ? 'icon-action_arrow_down' : 'icon-action_arrow_up'"
              class="icon icon-blue icon-lg"
            ></i>
          </div>
        </div>
        @if (!item.Collapse) {
          <div class="responseContent">
            @if (!item.HasComments) {
              <div class="responseBody">
                <div class="responseBodySubContent">
                  <div class="dispositionText">No Comments</div>
                </div>
              </div>
            }
            @if (item.HasComments) {
              <div class="responseBody" [innerHtml]="item.Response"></div>
            }
            @if (item.HasComments  && item.Attachments && item.Attachments.length > 0) {
              <div class="responseBody">
                <bbj-file-list
                  [fileList]="item.Attachments"
                  title="Attachments"
                  [allowMovingFiles]="allowMovingFiles()"
                  (movedFile)="attachmentOut($event)"
                  (movedFiles)="attachmentsOut($event)"
                ></bbj-file-list>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  <div class="contentBox">
    <div class="contentTitle">{{ isReviewer() ? "Pending Reviewer" : "Observer" }} list</div>

    @for (item of unsubmittedResponses; track item) {
      <div class="pendingBox">
        <div class="pendingHeader">
          <span>{{ item.ReviewerName }}</span>
          @if (item.ReviewerOrganization && item.ReviewerOrganization !== '') {
            <span>
              <span class="responseHeaderSeparate">|</span>{{ item.ReviewerOrganization }}
            </span>
          }
          @if (item.ReviewerTrackName && item.ReviewerTrackName !== '') {
            <span>
              <span class="responseHeaderSeparate">|</span>{{ item.ReviewerTrackName }}
            </span>
          }
          <div class="actions-wrapper">
            @if (showAddUserIcon()) {
              <div class="responseNotify" (click)="removeUserClick(item)">
                <i class="icon icon-social_user_remove icon-orange icon-lg" style="margin-right: 8px"></i>
                <span>Remove</span>
              </div>
            }
            @if (turnOnNotifyUser()) {
              <div class="responseNotify" (click)="notifyUser(item)">
                <i class="icon icon-notify icon-green icon-lg" style="margin-right: 8px"></i>
                <span>Notify User</span>
              </div>
            }
          </div>
        </div>
      </div>
    }

    @if (unsubmittedResponses.length === 0) {
      <div
        style="width: 100%; height: 100%; display: flex; align-items: center"
        >
        <div class="noItem-body">
          <div>
            <div class="noItem-icon-row icon icon-social_user_team_big icon-grey icon-xl"></div>
          </div>
          <div class="noItem-title-row">None</div>
        </div>
      </div>
    }

    @if (showAddUserIcon()) {
      <div style="position: absolute; top: 22px; right: 0; cursor: pointer">
        <div class="formGroupManu" (click)="openWindowClick()">+ Add {{ isReviewer() ? "Reviewers" : "Observers" }}</div>
      </div>
    }
  </div>
</div>
